import {Resizer} from 'yet-another-resizer'
const resizer = new Resizer({maxWidth: 1600, maxHeight: 2400})
const parser = new DOMParser()

export const imgInHTMLResize = text => {
  const dom = parser.parseFromString(text, 'text/html')
  const imgs = dom.querySelectorAll('img')
  const _promiseQueue = []
  const _indexes = []
  imgs.forEach((img, i) => {
    if (img.src && img.src.indexOf('data:image') !== -1) {
      _indexes.push(i)
      _promiseQueue.push(resizer.scaleImage(img))
    }
  })
  return Promise.all(_promiseQueue).then(imageDatas => {
    imageDatas.forEach((data, i) => {
      imgs[_indexes[i]].src = data
    })
    // return DOM content with resized images
    return dom.body.innerHTML
  })
}
